// extracted by mini-css-extract-plugin
export default {"bg":"NrQNtC","inlineContent":"jeiZjN","pageWrapper":"GAwiaa","shadow":"oNTwmw","leftTop":"rP1fQu","rightTop":"Y87IBi","centerTop":"I6OwSw","innerBg":"JBZfMB"};